<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            linkvideoajuda="https://www.youtube.com/embed/q8-WCjIwPeU"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="filter-select">
            <vue-select
              :options="equipes"
              label="no_esf_eap"
              placeholder="Último atendimento"
              @input="onChangeEquipe"
            >
              <template slot="option" slot-scope="option">
                {{ option.no_esf_eap }} -
                {{ option.ine_esf_eap }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div>
        </div>
        <div class="col-md-12">
          <div class="info-table">
            <div class="info-table-item">
              <vue-select
                :options="situacaoOptions"
                label="label"
                placeholder="Equipe inválida"
                v-model="situacao"
                @input="filtros(equipe, $event)"
                :clearable="true"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
            <div class="info-table-item">
              <download-files
                :callback-pdf="generatePdf"
                :data="displayedCadastros"
                :fields="dataFields"
                name="busca-ativa-cadastro"
              >
              </download-files>
            </div>
          </div>
          <TabelaCadastros :cadastros="cadastros" :loading="loading" />
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from './SectionTitle'
import { mapState } from 'vuex'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'
import * as Functions from './functions.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import TabelaCadastros from './components/TabelaCadastros.vue'

export default {
  name: 'BuscaAtivaCadastros',
  metaInfo: {
    title: 'Busca ativa cadastros',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    ShowHideField,
    DownloadFiles,
    TabelaCadastros,
  },
  data() {
    return {
      cadastrosOriginais: [],
      cadastros: [],
      loading: false,
      currentPage: 1,
      equipe: null,
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
      situacaoOptions: [
        { label: 'Saúde bucal', value: 'saude-bucal' },
        { label: 'eMulti', value: 'emulti' },
        { label: 'Outras', value: 'outras' },
      ],
      situacao: null,
    }
  },
  mixins: [utils],
  watch: {
    search: {
      handler(newValue) {
        if (newValue) {
          this.filterSearch({ filter: this.filterItems(newValue) })
          return
        }
        this.filterSearch({ filter: false })
      },
      deep: true,
    },
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros.map((item, index) => {
        return {
          id: index,
          ...item,
        }
      })
    },
    equipes() {
      return this.$store.state.equipesV2
    },
  },
  methods: {
    /**
     * Filtra os dados
     *
     * @param {*} equipe
     * @param {*} situacao
     */
    filtros(equipe, situacao) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais

      if (equipe != null) {
        data = data.filter((item) => {
          return item.nu_ine == equipe.ine_esf_eap
        })
      } else {
        data = data
      }

      if (situacao != null) {
        data = this.handleSituacao(data, situacao)
      }

      this.cadastros = data
    },

    /**
     * Filtra por situação
     *
     * @param {Array} data
     * @param {Object} event
     *
     * @returns {Array}
     */
    handleSituacao(data, event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      const situacao = event.value
      let filtrado = data.filter((item) => {
        if (situacao === 'saude-bucal') {
          return item.tp_ine_fci == '71'
        }

        if (situacao === 'emulti') {
          return item.tp_ine_fci == '72'
        }

        if (situacao === 'outras') {
          return item.tp_ine_fci == '-' || item.tp_ine_fci == null
        }

        return item
      })

      return filtrado
    },

    /**
     * Atualiza o estado do filtro de busca da tabela.
     * @param {Object} item Item selecionado
     */
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Manipula a alteração da equipe selecionada.
     *
     * @param {Object} event Equipe selecionada
     */
    async onChangeEquipe(event) {
      this.search = ''
      this.equipe = event
      this.filtros(event, this.situacao)
    },

    /**
     * Busca os dados
     */
    async buscarDados() {
      this.loading = true

      try {
        const { data } = await this.$api.get(
          `/app/busca-ativa-cadastro/${this.$store.state.cod_ibge}`
        )

        this.cadastrosOriginais = data
        this.cadastros = data
        this.filtros(this.equipe, this.situacao)
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Gera o relatório em PDF.
     */
    generatePdf() {
      Functions.generatePdf(this.displayedCadastros, this.equipe)
    },
  },
  created() {
    this.buscarDados()
  },
}
</script>

<style></style>
